import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'

import { FilterOptionButtons } from '../components/FilterOptionButtons'
import type { FilterOption, TimeDeadline } from '../types'
import type { CustomTimeDeadlineFilter } from './customFilters'

export const runoutOptions: FilterOption<TimeDeadline>[] = [
  { text: 'Empty', value: 'now' },
  { text: 'End of Today', value: 'today' },
  { text: 'End of Tomorrow', value: 'tomorrow' },
  { text: '4 Hours', value: 4 },
  { text: '8 Hours', value: 8 },
  { text: '12 Hours', value: 12 },
  { text: '18 Hours', value: 18 },
  { text: '24 Hours', value: 24 },
  { text: '48 Hours', value: 48 },
  { text: '72 Hours', value: 72 },
  { text: 'Next 7 Days', value: 7 * 24 },
]

export const noFitOptions: FilterOption<TimeDeadline>[] = [
  { text: 'Fits Now', value: 'now' },
  { text: 'AM Shift Today', value: 'am today' },
  { text: 'PM Shift Today', value: 'pm today' },
  { text: 'End of Today', value: 'today' },
  { text: 'End of Tomorrow', value: 'tomorrow' },
  { text: '4 Hours', value: 4 },
  { text: '8 Hours', value: 8 },
  { text: '12 Hours', value: 12 },
  { text: '18 Hours', value: 18 },
  { text: '24 Hours', value: 24 },
  { text: '48 Hours', value: 48 },
  { text: '72 Hours', value: 72 },
]

type TimeDeadlineFilterProps = {
  includeDrops?: boolean
  filterChangedCallback?: () => void
  filterOptions?: FilterOption<TimeDeadline>[]
  doesFilterPass: CustomTimeDeadlineFilter
}

export const TimeDeadlineFilter = forwardRef<any, TimeDeadlineFilterProps>(
  ({ includeDrops = false, doesFilterPass: customFilter, filterOptions = runoutOptions, ...props }, ref) => {
    const [selectedIndex, setSelectedIndex] = useState<number>()

    function handleSelect(value: number) {
      if (selectedIndex === value) setSelectedIndex(null)
      else setSelectedIndex(value)
    }

    useEffect(() => {
      props.filterChangedCallback()
    }, [selectedIndex])

    useImperativeHandle(ref, () => {
      return {
        doesFilterPass,
        isFilterActive,
      }
    })

    function doesFilterPass(params: any) {
      return customFilter(params, selectedIndex, filterOptions, includeDrops)
    }

    function isFilterActive() {
      return selectedIndex !== null && selectedIndex !== undefined
    }

    return <FilterOptionButtons options={filterOptions} handleClick={handleSelect} selectedIndex={selectedIndex} />
  }
)
